import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { useFormik } from "formik";
import { NivelI } from "interfaces/Nivel";
import { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { createNivelesSchema } from "schemas/niveles/CreateNivelesSchema";
import { postNiveles, putNiveles } from "services/niveles";
import { RootState } from "store/store";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: NivelI;
  onSuccess?: (titulo: NivelI) => void;
  showModal: boolean;
}

interface initialValues {
  id?: string | number;
  nombre: string;
}

export const NivelABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const initialValues: initialValues = {
    nombre: "",
  };
  const [isLoading, setIsLoading] = useState(false);

  const renderInitialValues = async () => {
    let currentValues;

    if (isEditMode && elemento) {
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
      };
    } else {
      currentValues = initialValues;
    }
    setValues(currentValues);
  };

  const handleSubmitCreate = async (params: any) => {
    try {
      setIsLoading(true);
      const newNivel = await postNiveles({ params });
      showSuccessToast("¡El nivel fue creado con éxito!");
      if (onSuccess) onSuccess(newNivel);
      onClose();
    } catch (err: any) {
      showErrorToast("El nivel no pudo ser creado.");
      console.log(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitEdit = async (params: any) => {
    try {
      setIsLoading(true);
      const newNivel = await putNiveles({ params });
      showSuccessToast("¡El nivel fue editado con éxito!");
      if (onSuccess) onSuccess(newNivel);
      onClose();
    } catch (err: any) {
      showErrorToast("El nivel no pudo ser creado.");
      console.log(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createNivelesSchema,
    onSubmit: actionType == "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa } = useSelector(
    (st: RootState) => st.appData,
  );

  useEffect(() => {
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  return (
    <>
      <Modal show={showModal} onHide={onClose} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Nivel" : "Nuevo Nivel"}
          </Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <Col>
              <Row>
                <Col sm={12}>
                  <Input
                    id={"nombre"}
                    title="Nombre del nivel"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="mx-3"
              variant="secondary"
              size="lg"
              onClick={onClose}
            >
              Cancelar
            </Button>
            {!isLoading && (
              <Button
                variant="primary"
                size="lg"
                className="user-submit-button"
                /* disabled={isSubmitting} */ type="submit"
              >
                {isEditMode ? "Guardar Cambios" : "Confirmar"}
              </Button>
            )}

            {isLoading && (
              <div className="d-flex justify-content-center w-full">
                <Spinner />
              </div>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
